import { StyleSheet, Platform } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export interface AvatarGroupStyleOptions {
  size: number;
  overlap: number;
  ringColor: string;
}

export const getAvatarGroupStyles = (theme: Theme, o: AvatarGroupStyleOptions) =>
  StyleSheet.create({
    row: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    stackRow: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    avatarSlot: {
      width: o.size,
      height: o.size,
      marginLeft: -o.overlap,
      position: 'relative',
      alignItems: 'center',
      ...(Platform.OS === 'web' && { cursor: 'auto' as const }),
    },
    avatarSlotFirst: {
      marginLeft: 0,
    },
    avatarRing: {
      width: o.size,
      height: o.size,
      borderRadius: o.size / 2,
      borderWidth: 3,
      borderColor: o.ringColor,
      backgroundColor: theme.background.cardElevated,
      overflow: 'hidden',
    },
    avatarImage: {
      width: o.size,
      height: o.size,
      borderRadius: o.size / 2,
    },
    avatarFallback: {
      width: o.size,
      height: o.size,
      borderRadius: o.size / 2,
      backgroundColor: theme.primary + '33',
      alignItems: 'center',
      justifyContent: 'center',
    },
    avatarFallbackText: {
      fontSize: Math.max(11, Math.round(o.size * 0.36)),
      fontWeight: '800',
      color: theme.primary,
    },
    plusChip: {
      width: o.size,
      height: o.size,
      borderRadius: o.size / 2,
      borderWidth: 3,
      borderColor: o.ringColor,
      backgroundColor: theme.primary,
      alignItems: 'center',
      justifyContent: 'center',
      marginLeft: -o.overlap,
      zIndex: 0,
    },
    plusChipText: {
      fontSize: Math.max(10, Math.round(o.size * 0.32)),
      fontWeight: '800',
      color: theme.white,
    },
    stackZ6: { zIndex: 6 },
    stackZ5: { zIndex: 5 },
    stackZ4: { zIndex: 4 },
    stackZ3: { zIndex: 3 },
    stackZ2: { zIndex: 2 },
    stackZ1: { zIndex: 1 },
    stackZ0: { zIndex: 0 },
    plusZ: { zIndex: 8 },
  });
